// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pl-0";
export var animationContainer = "_pl-1";
export var itemPrice = "_pl-a";
export var itemizedContent = "_pl-9";
export var itemizedHeader = "_pl-7";
export var itemizedRow = "_pl-8";
export var itemizedSection = "_pl-6";
export var modalContent = "_pl-2";
export var orderName = "_pl-3";
export var refundOption = "_pl-4";
export var refundOptionsContainer = "_pl-5";
export var shippingLabel = "_pl-b";
export var totalRow = "_pl-c";